import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Big from './assets/Big.jpg'
import Rev from './assets/Rev.jfif'
import Imp from './assets/imp.jpg'
import Add from './assets/add.jpg'
import Dll from './assets/Dll.png'
import stck from './assets/stck.jfif'
import Nle from './assets/NLE.png'
import Ed from './assets/Ed.png'
import Max from './assets/Max.png'
import pytha from './assets/pytha.jfif'
import bt from './assets/bt.jpg'
import lvl from './assets/lvl.jfif'
import island from './assets/island.jfif'
import stct from './assets/stct.png'
import orNot from './assets/orNot.png'
import bool from './assets/bool.png'
import bigNum from './assets/bigNum.jpg'
import CacheLRU from './assets/CacheLRU.jpg'
import diff from './assets/diff.png'
const Ind = () => {
    return (
        <div>
               <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={Big}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1.2rem', color:'green' }}>K largest elements from a big file or array</p>
      <NavLink to='/category/Amazon Interview question 1'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={Rev} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1.2rem', color:'green' }}>Reverse a Linked List in groups of given size</p>
      <NavLink to='/category/Amazon Interview question 2'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  

    
    <div class="card 2">
    <div class="card_image">
      <img src={Add} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1.2rem', color:'green' }}>Add two numbers represented by linked lists</p>
      <NavLink to='/category/Amazon Interview question 4'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={Dll} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1.2rem', color:'green' }}>Convert a Binary tree to DLL</p>
      <NavLink to='/category/Amazon Interview question 5'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={stck} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1.2rem', color:'green' }}>Stock span problem</p>
      <NavLink to='/category/Amazon Interview question 6'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={Nle} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1.2rem', color:'green' }}>Next larger element</p>
        <NavLink to='/category/Amazon Interview question 7'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={Ed} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1.2rem', color:'green' }}>Edit distance</p>
      <NavLink to='/category/Amazon Interview question 8'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={Max} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1.2rem', color:'green' }}>Maximum of all subarrays of size k</p>
      <NavLink to='/category/Amazon Interview question 9'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={pytha} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1.2rem', color:'green' }}>Pythagorean Triplet</p>
      <NavLink to='/category/Amazon Interview question 10'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={bt} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1.2rem', color:'green' }}>Print a Binary Tree in Vertical Order</p>
        <NavLink to='/category/Amazon Interview question 11'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={lvl} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1.2rem', color:'green' }}>Level order traversal</p>
      <NavLink to='/category/Amazon Interview question 12'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={island} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1.2rem', color:'green' }}>Find the number of islands</p>
      <NavLink to='/category/Amazon Interview question 14'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={stct} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1.2rem', color:'green' }}>Detect and Remove Loop in a Linked List</p>
      <NavLink to='/category/Interview question 15'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={orNot} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1.2rem', color:'green' }}>Check if a binary tree is BST or not</p>
        <NavLink to='/category/Amazon Interview question 16'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={bool} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1.2rem', color:'green' }}>Boolean Parenthesization</p>
      <NavLink to='/category/Amazon Interview question 17'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
         
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={bigNum} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1.2rem', color:'green' }}>Arrange given numbers to form the biggest number</p>
      <NavLink to='/category/Amazon Interview question 18'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={CacheLRU} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1.2rem', color:'green' }}>Implement LRU Cache</p>
      <NavLink to='/category/Amazon Interview question 19'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={diff} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1.2rem', color:'green' }}>Maximum difference between node and its ancestor in Binary Tree</p>
        <NavLink to='/category/Amazon Interview question 20'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
   
    </div>
        </div>
    )
}

export default Ind
